import PropTypes from "prop-types";
import { ArrowLeftOutlined } from "@/config/antd";
import { useNavigate } from "react-router-dom";

const Back = ({
  text = "Back",
  color = "primary",
  arrowColor = "primary",
  bold = true,
  removeText = false,
  onClick,
  className = "",
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      const path = onClick();
      if (path) {
        navigate(path);
      } else {
        onClick();
      }
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center text-${color} hover:text-primary-dark transition-colors ${className}`}
      data-testid="back-button">
      <ArrowLeftOutlined className={`mr-1 text-${arrowColor}`} />
      {!removeText && (
        <span className={`text-small ${bold ? "font-bold" : ""} text-black`}>
          {text}
        </span>
      )}
    </button>
  );
};

Back.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  bold: PropTypes.bool,
  onClick: PropTypes.func,
  removeText: PropTypes.bool,
  className: PropTypes.string,
  arrowColor: PropTypes.string,
};

export default Back;
